export enum Permissions {
  ALL = '*',

  ALUNO_APROVA_TOTAL = 'aluno.aprova_total',
  GAMIFICACAO = 'gamificacao',
  COMUNIDADE = 'comunidade',
  FAVORITOS = 'favoritos',

  // Minha Área
  MINHA_AREA = 'minha_area',
  MINHA_AREA_FAVORITOS = 'minha_area.favoritos',
  MINHA_AREA_MEUS_EVENTOS = 'minha_area.meus_eventos',
  MINHA_AREA_DOSSIES_DE_INCIDENCIA = 'minha_area.dossies_de_incidencia',
  MINHA_AREA_AULA_DESTAQUE = 'minha_area.aula_destaque',
  MINHA_AREA_MINHAS_METRICAS = 'minha_area.minhas_metricas',
  MINHA_AREA_DESENPENHO_REDACAO = 'minha_area.desempenho_redacao',
  MINHA_AREA_CURSO = 'minha_area.curso',
  MINHA_AREA_ULTIMOS_CONTEUDOS_VISTOS = 'minha_area.ultimos_conteudos_vistos',
  MINHA_AREA_MARKETING_BANNERS = 'minha_area.marketing_banners',

  // Trilhas de Ensino
  TRILHAS_DE_ENSINO_CRONOGRAMA_PERSONALIZADO = 'trilhas_de_ensino.cronograma_personalizado',
  TRILHAS_DE_ENSINO_CURSOS_REGULARES = 'trilhas_de_ensino.cursos.regulares',
  TRILHAS_DE_ENSINO_CURSOS_COMPLEMENTARES = 'trilhas_de_ensino.cursos.complementares',
  TRILHAS_DE_ENSINO_TREINO_DE_ELITE = 'trilhas_de_ensino.treino_de_elite',
  TRILHAS_DE_ENSINO_ESQUADRAO = 'trilhas_de_ensino.esquadrao',
  TRILHAS_DE_ENSINO_REGIONAIS = 'trilhas_de_ensino.regionais',

  // Disciplinas
  DISCIPLINAS_INTERDISCIPLINAR = 'disciplinas.interdisciplinar',
  DISCIPLINAS_BIOLOGIA = 'disciplinas.biologia',
  DISCIPLINAS_FISICA = 'disciplinas.fisica',
  DISCIPLINAS_QUIMICA = 'disciplinas.quimica',
  DISCIPLINAS_MATEMATICA = 'disciplinas.matematica',
  DISCIPLINAS_HISTORIA = 'disciplinas.historia',
  DISCIPLINAS_GEOGRAFIA = 'disciplinas.geografia',
  DISCIPLINAS_ATUALIDADES = 'disciplinas.atualidades',
  DISCIPLINAS_FILOSOFIA = 'disciplinas.filosofia',
  DISCIPLINAS_SOCIOLOGIA = 'disciplinas.sociologia',
  DISCIPLINAS_PORTUGUES = 'disciplinas.portugues',
  DISCIPLINAS_LITERATURA = 'disciplinas.literatura',
  DISCIPLINAS_REDACAO = 'disciplinas.redacao',
  DISCIPLINAS_INGLES = 'disciplinas.ingles',
  DISCIPLINAS_ESPANHOL = 'disciplinas.espanhol',

  // Disciplinas Universitário
  DISCIPLINAS_EMBRIOLOGIA = 'disciplinas.embriologia',
    DISCIPLINAS_FARMACOLOGIA = 'disciplinas.farmacologia',
  DISCIPLINAS_FISIOLOGIA = 'disciplinas.fisiologia',
  DISCIPLINAS_GENETICA = 'disciplinas.genetica',
  DISCIPLINAS_ANATOMIA = 'disciplinas.anatomia',
  DISCIPLINAS_BIOQUIMICA = 'disciplinas.bioquimica',
  DISCIPLINAS_HISTOLOGIA = 'disciplinas.histologia',
  DISCIPLINAS_IMUNOLOGIA = 'disciplinas.imunologia',
  DISCIPLINAS_PARASITOLOGIA = 'disciplinas.parasitologia',
  DISCIPLINAS_PATOLOGIA = 'disciplinas.patologia',
  DISCIPLINAS_MICROBIOLOGIA = 'disciplinas.microbiologia',

  // Redação
  REDACAO_MINHAS_REDACOES = 'redacao.minhas_redacoes',
  REDACAO_TEMAS = 'redacao.temas',

  // Simulados
  SIMULADOS_SIMULADOR = 'simulados.simulador',
  SIMULADOS_SIMULADOS_ENEM = 'simulados.simulados_enem',

  // Ao Vivo
  AO_VIVO_MONITORIAS = 'ao_vivo.monitorias',
  AO_VIVO_LIVES = 'ao_vivo.lives',
  AO_VIVO_APROVA_LIVE = 'ao_vivo.aprova_live',
  AO_VIVO_CHALLENGE_60_DIAS = 'ao_vivo.desafio-60-dias-2025',

  // Conexões com Jubilut
  CONEXOES_JUBILUT = 'conexoes.jubilut',

  // Indicações
  INDICACOES = 'indicacoes',

  // Memory
  MEMORY = 'memory',
}
